import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

const RoleService = Services.roles;
export default {
  [VT.ROLES_LIST]: ({ commit, state }, page = 1) => {
    state.rolesList['status'] = statuses.LOADING;
    RoleService.list(page).then((data) => {
      commit(VT.ROLES_LIST, data);
    }).catch((errResponse) => {
      commit(VT.ROLES_LIST, errResponse);
    });
  },
  [VT.ROLE_CREATE_DATA]: ({ commit, state }) => {
    state.roleCreateData['status'] = statuses.LOADING;
    RoleService.createData().then((data) => {
      commit(VT.ROLE_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(VT.ROLE_CREATE_DATA, errResponse);
    });
  },
  [VT.ROLE_UPDATE_DATA]: ({ commit, state }, roleId) => {
    state.roleUpdateData['status'] = statuses.LOADING;
    RoleService.editData(roleId).then((data) => {
      commit(VT.ROLE_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(VT.ROLE_UPDATE_DATA, errResponse);
    });
  },
  [VT.ROLE_CREATE]: ({ commit, state }, createData) => {
    state.roleCreate['status'] = statuses.LOADING;
    RoleService.create(createData).then((data) => {
      commit(VT.ROLE_CREATE, data);
    }).catch((errResponse) => {
      commit(VT.ROLE_CREATE, errResponse);
    });
  },
  [VT.ROLE_UPDATE]: ({ commit, state }, { id, update }) => {
    state.roleUpdate['status'] = statuses.LOADING;
    RoleService.update(id, update).then((data) => {
      commit(VT.ROLE_UPDATE, data);
    }).catch((errResponse) => {
      commit(VT.ROLE_UPDATE, errResponse);
    });
  },
};
